import $ from 'jquery';

const defaults = {
  slickInstance: null,
  slickContainer: null,
  attachTo: null,
  playBtn: '<button class="slick-play slick-btn" type="button" aria-label="Play">Play</button>',
  pauseBtn: '<button class="slick-pause slick-btn" type="button" aria-label="Pause">Pause</button>',
};

export default class PlayPauseControls {
  constructor(slickContainer, options) {
    // assign variables
    this.slickContainer = slickContainer;
    this.slickInstance = slickContainer.get(0).slick;
    this.settings = Object.assign({}, defaults, options);

    // set scope
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);

    // create
    this.$playBtn = this.addPlayBtn();
    this.$pauseBtn = this.addPauseBtn();

    // set breakpoint listener
    this.slickContainer.on('breakpoint', this.onBreakpointChange);

    // set current state
    this.setCurrentBreakpointState();
  }

  addPlayBtn() {
    return $(this.settings.playBtn);
  }

  addPauseBtn() {
    return $(this.settings.pauseBtn);
  }

  addControls() {
    // Allows the controls to be attached to a passed jQuery object or default
    // to the passed in container
    if (!this.settings.attachTo) {
      this.settings.attachTo = this.slickContainer;
    }

    // Add play and pause the controls and finally add the controls container
    this.settings.attachTo.prepend(this.$playBtn, this.$pauseBtn);

    // Add click handlers to each button to control autoplay functionality
    this.$playBtn.on('click', this.play);
    this.$pauseBtn.on('click', this.pause);

    // set the current state of these buttons we just added
    this.setCurrentState();
  }

  removeControls() {
    // remove the buttons
    this.$playBtn.off('click', this.play).remove();
    this.$pauseBtn.off('click', this.pause).remove();
  }

  play(event) {
    event.preventDefault();
    if (this.slickInstance.paused) {
      this.slickContainer.slick('slickPlay');
    }
    this.setCurrentState();
  }

  pause(event) {
    event.preventDefault();
    if (!this.slickInstance.paused) {
      this.slickContainer.slick('slickPause');
    }
    this.setCurrentState();
  }

  setPlayState() {
    this.$playBtn.attr('aria-hidden', 'false');
    this.$pauseBtn.attr('aria-hidden', 'true');
  }

  setPauseState() {
    this.$playBtn.attr('aria-hidden', 'true');
    this.$pauseBtn.attr('aria-hidden', 'false');
  }

  setCurrentBreakpointState() {
    const { activeBreakpoint } = this.slickInstance;
    let { autoplay } = this.slickInstance.options;

    // check to see if the current breakpoint adjusts the autoplay setting
    if (activeBreakpoint) {
      ({ autoplay } = this.slickInstance.breakpointSettings[activeBreakpoint]);
    }

    // manage our controls accordingly
    if (autoplay) {
      this.addControls();
    } else {
      this.removeControls();
    }
  }

  setCurrentState() {
    if (this.slickInstance.paused) {
      this.setPlayState();
    } else {
      this.setPauseState();
    }
  }

  // Integrates with the slick carousel breakpoint functionality
  onBreakpointChange() {
    this.setCurrentBreakpointState();
  }
}
